<div class="row">
  <a class="back-button" [routerLink]="'/devices'"><i class="mdi mdi-arrow-left"></i> Back to Devices</a>
</div>
<div class="row" *ngIf="device">
  <div class="col-4 grid device-card device-image"></div>
  <div class="col-md-8 col-12 device-header-container">
    <div class="device-header">
      <div class="split-header">
        <div>
          <h4>{{device.name}}</h4>
          <a class="btn action-btn btn-cs component-flat" routerLink="edit">
            <i class="mdi mdi-lead-pencil"></i>
          </a>
          <img *ngIf="device.online && device.rssi_value" class="signal-icon" src="/assets/images/signal-{{device.rssi_value}}.png" />
          <span *ngIf="!device.rssi_value || !device.online" class="badge device-status" [class.badge-success]="device.online" [class.badge-danger]="!device.online">{{device.online ? 'Online' : 'Offline'}}</span>
        </div>
        <div>
          <span class="badge bg-primary" *ngIf="device.connection_status === 'disconnected' && device.online" (click)="deviceService.activateDevice(device.id)">Connect</span>
          <span class="badge bg-success" *ngIf="device.connection_status === 'connected'" (click)="deviceService.deactivateDevice(device.id)">Connected</span>
          <span *ngIf="device.connection_status === 'connecting'" class="badge bg-primary">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">Loading...</span>
          </span>
        </div>
      </div>
    </div>
    <div class="grid device-card">
      <div *ngIf="!device.editing" class="grid-body text-gray row device-inline-card">
        <div class="device-info col-6 col-md-4">
          <span class="info-label">MAC/Serial</span>
          {{device.code}}
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Organization</span>
          {{device.org?.name}}
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Site</span>
          {{device.location?.company}}
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">LAN IP Address</span>
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Netmask</span>
          {{device.subnet_mask}}
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">VPN IP Address</span>
          {{device.vpn_ip}}
        </div>
        <button type="button" class="btn action-btn btn-cs component-flat device-edit-button" (click)="device.editing = true;">
          <i class="mdi mdi-lead-pencil"></i>
        </button>
      </div>
      <div *ngIf="device.editing" class="grid-body text-gray row device-input-card">
        <div class="device-info col-6 col-md-4">
          <span class="info-label">MAC/Serial</span>
          {{device.code}}
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Organization</span>
          <select [(ngModel)]="device.org_id" class="form-control ng-pristine ng-valid ng-touched" name="org_id" required="">
            <option *ngFor="let subOrg of organizationService.subOrgs" [value]="subOrg.id">
              {{subOrg.name}}
            </option>
          </select>
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Site</span>
          <select [(ngModel)]="device.location_id" class="form-control ng-pristine ng-valid ng-touched" name="location_id" required="">
            <option *ngFor="let location of locationService.locations | locationOrgFilter:device.org_id" [value]="location.id">
              {{location.company}}
            </option>
          </select>
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">LAN IP Address</span>
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">Netmask</span>
          <input type="text" [(ngModel)]="device.subnet_mask" class="form-control" />
        </div>
        <div class="device-info col-6 col-md-4">
          <span class="info-label">VPN IP Address</span>
          <input type="text" [(ngModel)]="device.vpn_ip" class="form-control" />
        </div>
        <div class="device-info col-6 col-md-4">
          <button type="button" class="btn btn-success" (click)="saveDevice()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Action Buttons -->
<div class="row" *ngIf="device && device.online && device.connection_status === 'connected'">
  <div class="col-lg-12">
    <div class="grid">
      <div class="item-wrapper">
        <div class="table-responsive">
          <table class="table table-responsive-md">
            <tbody>
              <tr>
                <td>
                  <a class="btn btn-primary" href="http://{{device.vpn_ip | ipDestination}}" target="_blank">Admin Panel</a>
                </td>
                <td>
                  <button class="btn btn-danger" (click)="deviceService.reboot(device)">
                    <i class="mdi mdi-power"></i>
                  </button>
                </td>
                <td>
                  <a class="btn btn-success text-white" *ngIf="!guacUrl && !this.guacLoading" (click)="authenticateGuac(device)">Connect to PC</a>
                  <a class="btn btn-primary" href="http://{{guacUrl}}" target="_blank" *ngIf="device.online && device.connection_status === 'connected' && guacUrl && !this.guacLoading">Remote Desktop</a>
                  <span *ngIf="this.guacLoading" class="badge bg-primary">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Connecting...</span>
                  </span>
                <td>
                <td *ngIf="device.serial">
                  <a class="btn btn-primary text-white" (click)="openSerialTerminalModal(serialContent)">Serial Terminal</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Cellular Info -->
<div class="row" *ngIf="device && device.hologram_device_id">
  <div class="col-lg-12">
    <div class="grid">
      <div class="item-wrapper">
        <div class="">
          <table class="table table-responsive-md">
            <thead>
              <th>Hologram ID</th>
              <th>Usage</th>
              <th>State</th>
            </thead>
            <tbody>
              <tr>
                <td>{{device.hologram_device_id}}</td>
                <td>{{device.cell_usage?.value}}{{device.cell_usage?.unit}} / {{device.cell_limit?.value}}{{device.cell_limit?.unit}}</td>
                <td>
                  <button *ngIf="device.cell_state === 'live'" class="btn btn-danger" (click)="changeDeviceState()">
                    <i class="mdi mdi-pause"></i>
                  </button>
                  <button *ngIf="device.cell_state === 'paused'" class="btn btn-success" (click)="changeDeviceState()">
                    <i class="mdi mdi-play"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Controller Section -->
<div class="row controller-container" *ngIf="device && device?.getIpsLength">
  <div class="col-lg-12">
    <div class="grid">

      <div class="grid-header split-header">
        <span>{{ device?.getIpsLength() }} Controller<span *ngIf="device.connections.length > 1">s</span></span>
        <div class="dropdown">
          <a class="btn btn-primary text-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Add New
          </a>
          <div class="dropdown-menu" x-placement="bottom">
            <a (click)="addController(1)" class="dropdown-item">Eclypse</a>
            <a (click)="addController(2)" class="dropdown-item">Mosaic</a>
            <a (click)="addController(3)" class="dropdown-item">Crestron</a>
            <a (click)="addController(4)" class="dropdown-item">Hubbell</a>
          </div>
        </div>
      </div>

      <div class="item-wrapper">
        <div class="">
          <table class="table table-responsive-md">
            <thead>
              <th>Controller</th>
              <th>Label</th>
              <th>IP Address</th>
              <th>Description</th>
              <th>24V?</th>
              <th>Links</th>
              <th>Actions</th>
            </thead>
            <tbody *ngFor="let controller of activeControllers">
              <tr *ngFor="let ip of controller.ips">
                <td>{{controller.vendor?.name}}</td>
                <td>
                  <span class="controller-field">{{ip.label}}</span>
                </td>
                <td>
                  <span *ngIf="!ip.editing" class="controller-field">{{ip.ip}}</span>
                  <input *ngIf="ip.editing" [(ngModel)]="ip.ip" type="text" class="form-control" />
                </td>
                <td>
                  <span *ngIf="!ip.editing" class="controller-field">{{ip.description}}</span>
                  <input *ngIf="ip.editing" [(ngModel)]="ip.description" class="form-control"/>
                </td>
                <td>
                  <i *ngIf="!ip.editing && device.relay_controller_id == ip.id" class="mdi mdi-check"></i>
                  <input type="checkbox" *ngIf="ip.editing" [(ngModel)]="ip.relay" />
                </td>
                <td>
                  <div class="btn-group" *ngIf="device.connection_status === 'connected' && !ip.editing">
                    <a class="btn btn-primary" href="{{controller.vendor.name === 'paradigm' ? 'http' : 'https'}}://{{ip.ip}}" target="_blank">{{controller.vendor.name}}</a>
                    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split text-white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <span class="visually-hidden">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu" x-placement="bottom-end" style="position: absolute; transform: translate3d(-110px, 25px, 0px); top: 0px; left: 0px; will-change: transform;">
                      <a *ngFor="let link of controller.vendor.links" href="https://{{ip.ip}}{{link.path}}" target="_blank" class="dropdown-item">{{link.text}}</a>
                      <a href="{{controller.path}}" target="_blank" class="dropdown-item">{{controller.vendor.default_path_text}}</a>
                      <a class="dropdown-item" (click)="deviceService.rebootController(device.vpn_ip)" *ngIf="ip.id === device.relay_controller_id">Power Cycle</a>
                    </div>
                  </div>
								</td>
                <td>
                  <div class="dropdown" *ngIf="!ip.editing">
                    <button type="button" class="btn btn-trasnparent action-btn btn-xs component-flat" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="mdi mdi-dots-vertical"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" (click)="editIP(ip)">Edit</a>
                      <a class="dropdown-item" (click)="deleteIP(ip)">Delete</a>
                    </div>
                  </div>
                  <div class="btn-group" *ngIf="ip.editing">
                    <button type="button" class="btn btn-primary" (click)="saveIP(controller, ip)">
                      <i class="mdi mdi-check"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #serialContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Serial Terminal</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-serial-terminal [currSerial]="device.serial"></app-serial-terminal>
  </div>
</ng-template>
